import { Box } from '@mui/material';
import { type FC, useMemo } from 'react';
import { useVoice } from '../../contexts/VoiceContext';
import { VoiceModalAudioTranscript } from './VoiceModalAudioTranscript';

interface VoiceModalProcessingViewProps {
  playbackProgress: number;
  isPlaying: boolean;
  onPlayback: () => void;
}

export const VoiceModalProcessingView: FC<VoiceModalProcessingViewProps> = ({
  playbackProgress,
  isPlaying,
  onPlayback,
}) => {
  const { transcript, recordedWaveform } = useVoice();
  const waveformBars = useMemo(
    () => (recordedWaveform.length > 0 ? recordedWaveform : Array(48).fill(0.2)),
    [recordedWaveform]
  );
  return (
  <Box
    sx={{
      background: 'transparent',
      border: '1px solid rgba(255,255,255,0.08)',
      borderRadius: '14px',
      p: 1.5,
      mb: 1.75,
    }}
  >
    <VoiceModalAudioTranscript
      transcript={transcript}
      waveformBars={waveformBars}
      playbackProgress={playbackProgress}
      isPlaying={isPlaying}
      onPlayback={onPlayback}
      isProcessing
    />
  </Box>
  );
};
